/* @flow */
import * as React from 'react';

const Minus = props => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    stroke="#505FB4"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M1,8 L15,8" />
  </svg>
);

export default Minus;



// WEBPACK FOOTER //
// ./src/assets/images/icons/minus.js